import {Component, computed, effect, inject, input, output, ChangeDetectionStrategy} from "@angular/core"
import {MatTooltipModule} from "@angular/material/tooltip"
import {cardAnimations} from "@app/common/components/cards/animations"
import {BaseSelectComponent} from "@app/platform/components/base/base-select/base-select.component"
import {MaterialReference} from "@cm/template-nodes"
import {CardErrorComponent} from "@common/components/cards/card-error/card-error.component"
import {CardPlaceholderComponent} from "@common/components/cards/card-placeholder/card-placeholder.component"
import {InfiniteListComponent} from "@common/components/lists/infinite-list/infinite-list.component"
import {fetchThrowingErrors} from "@common/helpers/api/fetch"
import {AuthService} from "@common/services/auth/auth.service"
import {MaterialFilterInput} from "@generated"
import {TemplateAddCardComponent} from "@app/template-editor/components/template-add-card/template-add-card.component"
import {
    TemplateAddMaterialItemFragment,
    TemplateAddMaterialItemsGQL,
} from "@app/template-editor/components/template-add-material/template-add-material.generated"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-template-add-other-mesh-specific-material",
    templateUrl: "./template-add-other-mesh-specific-material.component.html",
    styleUrl: "./template-add-other-mesh-specific-material.component.scss",
    animations: [...cardAnimations],
    imports: [InfiniteListComponent, CardErrorComponent, TemplateAddCardComponent, CardPlaceholderComponent, MatTooltipModule],
})
export class TemplateAddOtherMeshSpecificMaterial extends BaseSelectComponent<TemplateAddMaterialItemFragment, MaterialFilterInput> {
    readonly $search = input.required<string>({alias: "search"})
    readonly materialsGql = inject(TemplateAddMaterialItemsGQL)
    private rawData = this.implementDataLoader(fetchThrowingErrors(this.materialsGql))
    readonly $data = computed(() => this.rawData().items.map((item) => ({...item, node: item.data ? this.getMaterialReference(item.data) : undefined})))
    readonly onItemClicked = output()

    private readonly auth = inject(AuthService)

    constructor() {
        super()
        this.$customFilters.set({hasCyclesMaterial: true, meshSpecific: true})

        effect(() => {
            this.$lockOrganization.set(!this.auth.$actingAsStaff())
        })

        effect(() => {
            const search = this.$search()
            this.searchText$.next(search)
        })
    }

    private getMaterialReference(data: TemplateAddMaterialItemFragment) {
        const materialRevisionId = data.latestCyclesRevision?.legacyId
        if (materialRevisionId === undefined) throw new Error("Material revision ID is undefined")

        return new MaterialReference({parameters: {name: data.name ?? "New Material Reference", materialId: data.legacyId, materialRevisionId: null}})
    }
}
